import script from "./StudentStayEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentStayEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentStayEditDialog.vue?vue&type=style&index=0&id=545a5237&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545a5237"]])

export default __exports__